class HoveredElement {
	constructor() {
		this.archiveCongres = document.querySelector('.post-type-archive-congres');
		if (!this.archiveCongres) {
			return;
		}
		this.congres = document.querySelectorAll(".congres-card");
		this.addHoverApparence();
	}

	addHoverApparence(){
		this.congres.forEach(congresCard => {
			congresCard.addEventListener("mouseenter", () => {
				const btnLink = congresCard.querySelector('.btn-link');
				btnLink.classList.add('hovered');
			});

			congresCard.addEventListener("mouseleave", () => {
				const btnLink = congresCard.querySelector('.btn-link');
				btnLink.classList.remove('hovered');
			});
		});
	}
}